import React, { useEffect, useCallback, useRef } from 'react';
import c from 'classnames';
import lottie from 'lottie-web';
import './style.scss';
var LottieAnimation = /*#__PURE__*/React.forwardRef(function (props, ref) {
  var id = props.id,
    className = props.className,
    ariaLabel = props.ariaLabel,
    data = props.data;
  var DIRECTION_FORWARD = 1;
  var DIRECTION_BACKWARDS = -1;
  var lottieClasses = c('Lottie', className);
  var refInternal = useRef(null);
  var lottieAnimation = ref || refInternal;
  var lottieId = id || (data ? data.nm : null);

  /*
  * Initial load of the Lottie animation
  */
  var loadAnimation = useCallback(function () {
    var renderer = props.renderer,
      rendererSettings = props.rendererSettings,
      direction = props.direction,
      loop = props.loop,
      autoPlay = props.autoPlay,
      path = props.path,
      speed = props.speed,
      segments = props.segments,
      activateOnHover = props.activateOnHover,
      startPosition = props.startPosition,
      onInit = props.onInit;
    lottieAnimation.current = lottie.loadAnimation({
      animationData: data,
      container: document.getElementById("lottie--".concat(lottieId)),
      renderer: renderer,
      rendererSettings: rendererSettings,
      direction: direction,
      loop: activateOnHover ? false : loop,
      autoplay: activateOnHover ? false : autoPlay,
      path: path
    });
    onInit(lottieAnimation.current);

    // Set the default speed.
    lottieAnimation.current.setSpeed(speed);
    // Play segments if we have them.
    if (segments) {
      lottieAnimation.current.playSegments(segments);
    }
    // If startPosition is defined use it as a starting frame, startPosition should be between 0 and 1.
    if (startPosition) {
      var startingFrame = Math.round(lottieAnimation.current.totalFrames * startPosition);
      lottieAnimation.current.goToAndStop(startingFrame, true);
    }
  }, [data, lottieAnimation, lottieId, props]);

  /*
  * Reverse direction on Mouse enter.
  */
  var onMouseEnter = function onMouseEnter(e) {
    var activateOnHover = props.activateOnHover;
    if (activateOnHover) {
      lottieAnimation.current.setDirection(DIRECTION_FORWARD);
      lottieAnimation.current.play();
    }
  };

  /*
  * Reverse direction on Mouse leave
  */
  var onMouseLeave = function onMouseLeave() {
    var activateOnHover = props.activateOnHover;
    if (activateOnHover) {
      lottieAnimation.current.setDirection(DIRECTION_BACKWARDS);
      lottieAnimation.current.play();
    }
  };

  /*
  * Toggle the animation on click
  */
  var onClick = function onClick() {
    var pauseOnClick = props.pauseOnClick;
    if (pauseOnClick) {
      if (lottieAnimation.current.isPaused) {
        lottieAnimation.current.play();
      } else {
        lottieAnimation.current.pause();
      }
    }
  };

  // Init the Lottie animation.
  useEffect(function () {
    var onDestroy = props.onDestroy;
    loadAnimation();
    return function () {
      onDestroy(lottieAnimation.current);
      lottieAnimation.current.destroy();
    };
  }, [props, loadAnimation, lottieAnimation]);
  return (
    /*#__PURE__*/
    // eslint-disable-next-line jsx-a11y/interactive-supports-focus
    React.createElement("div", {
      onMouseEnter: onMouseEnter,
      onMouseLeave: onMouseLeave,
      onClick: onClick,
      className: lottieClasses,
      id: "lottie--".concat(lottieId),
      "aria-label": ariaLabel,
      role: "button"
    })
  );
});
export default LottieAnimation;